import React, { Component } from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import Header from './HeaderComponent';
import Footer from './FooterComponent';
import Home from './HomeComponent';
import PortBuilder from './PortfolioBuilderComponent';
import PortSignature from './PortfolioSignatureComponent';
import PortLoad from './PortfolioLoadComponent';
import PortParams from './PortfolioParamsComponent';
import PortMetrics from './PortfolioMetricsComponent';
import PortCompar from './PortfolioComparComponent';
import PortComparMetrics from './PortfolioComparMetricsComponent';
import PortTactical from './PortfolioTacticalComponent';
import PortTacticalFunds from './PortfolioTacticalFundsComponent';
import Catalog from './CatalogComponent';
import Assets from './OptimAssetsComponent';
import Params from './OptimParamsComponent';
import PortOptim from './OptimResultsComponent';
import FundsSelect from './FundsSelectComponent';
import ClientPortLoad from './ClientPortfolioLoadComponent'; 
import ClientPortExposure from './ClientPortfolioExposure'; 
import ClientPortMetrics from './ClientPortfolioMetrics';
import ClientPortSuitability from './ClientPortfolioSuitability';
import ClientPortAdjust from './ClientPortfolioAdjust';
import ChatStrategy from './LLMStrategyComponent';
import Suitability from './SuitabilityComponent';
import SuitabilityReport from './SuitabilityReportComponent';
import Downloads from './DownloadsComponent';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { getUser, fetchSeries, fetchData } from '../redux/ActionCreators';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import { Auth } from 'aws-amplify';
import { userSignout } from '../redux/ActionCreators';
import * as ActionTypes from '../redux/ActionType';

//import { baseUrl } from '../shared/baseUrl';
const mapStateToProps = state => {
  return {
    user_wm: state.user_wm,
  }
};

const SESSION_TIMEOUT_MS = 15 * 60 * 1000;
const ACTIVITY_EVENTS = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart', 'click'];

const mapDispatchToProps = (dispatch) => ({
  resetModel: (model) => {dispatch(actions.reset(model))},
  changeModel: (model,values) => {dispatch(actions.change(model, values))},
  addPort: (port_id) => {dispatch({type:ActionTypes.ADD_PORT, payload:port_id})},
  updateState: (action, payload) => {dispatch({type:action, payload:payload})},
  getUser: (username, token, ms=10, n=3) => {dispatch(getUser(username, token, ms, n))},
  fetchSeries: (tickers, token, ms=10, n=3) => {dispatch(fetchSeries(tickers, token, ms, n))},
  fetchData: (data, endpoint, actions, n=1, key=null) => dispatch(fetchData(data, endpoint, actions, n, key)), //without {} the function returns the promise
  resetErr: (action) => {dispatch({type:action, payload:null})},
  userSignout: () => dispatch(userSignout())
});

//connect method connects store to app.
class Main extends Component {
  constructor(props){
      super(props);
      this.state = {
          isNavOpen: false,
          isModalOpen: false,
      };
  }

  timeoutId = null;
  componentDidMount() {
    // Existing: load user info
    Auth.currentUserInfo().then(res => {
      if (this.props.user_inv?.data == null) {
        Auth.currentSession().then(res2 => {
          this.props.getUser(res.username, res2.getIdToken().getJwtToken());
        });
      }
    });
  
    // New: inactivity timer
    ACTIVITY_EVENTS.forEach((evt) =>
      window.addEventListener(evt, this.resetTimer, { passive: true })
    );
    this.resetTimer();
  }

  componentWillUnmount() {
    ACTIVITY_EVENTS.forEach((evt) =>
      window.removeEventListener(evt, this.resetTimer)
    );
    clearTimeout(this.timeoutId);
  }

  resetTimer = () => {
    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(this.handleLogout, SESSION_TIMEOUT_MS);
  };

  handleLogout = async () => {
    clearTimeout(this.timeoutId);
    // this.props.userSignout();
    // try {
    //   await Auth.signOut();
    // } finally {
    //   window.location.replace(window.location.origin);
    // }
    await Auth.signOut();
    window.location.replace(window.location.origin);
    this.props.userSignout();

  };
  render() {
    return (
      <div className="container-fluid">
        <Header  onLogout={this.handleLogout}/>
          <TransitionGroup>
            <CSSTransition classNames="fade" timeout={300}>
              <div>
                <Switch>
                  <Route exact path="/home" component={() => <Home changeModel={this.props.changeModel} />} />
                  <Route exact path="/catalog" component={() => <Catalog fetchSeries={this.props.fetchSeries} changeModel={this.props.changeModel} resetModel={this.props.resetModel} />} />
                  <Route exact path="/builder/optim/assets" component={() => <Assets fetchSeries={this.props.fetchSeries} changeModel={this.props.changeModel} resetModel={this.props.resetModel} />} />
                  <Route exact path="/builder/optim/params" component={() => <Params fetchData={this.props.fetchData} changeModel={this.props.changeModel} updateState={this.props.updateState} resetModel={this.props.resetModel} resetErr={this.props.resetErr} />} />
                  <Route exact path="/builder/optim/results" component={() => <PortOptim fetchData={this.props.fetchData} changeModel={this.props.changeModel} addPort={this.props.addPort} resetErr={this.props.resetErr}  updateState={this.props.updateState} />} />
                  <Route exact path="/builder/fix" component={() => <PortBuilder changeModel={this.props.changeModel} addPort={this.props.addPort} />}  />
                  <Route exact path="/builder/signature" component={() => <PortSignature changeModel={this.props.changeModel} addPort={this.props.addPort} />} />
                  <Route exact path="/builder/load" component={() => <PortLoad changeModel={this.props.changeModel} />} />
                  <Route exact path="/portfolio/backtest/params" component={() => <PortParams changeModel={this.props.changeModel} fetchData={this.props.fetchData} />} />
                  <Route exact path="/portfolio/backtest/results" component={() => <PortMetrics changeModel={this.props.changeModel} />} />
                  <Route exact path="/portfolio/compar/params" component={() => <PortCompar changeModel={this.props.changeModel} fetchData={this.props.fetchData} />} />
                  <Route exact path="/portfolio/compar/results" component={() => <PortComparMetrics changeModel={this.props.changeModel} />} />
                  <Route exact path="/portfolio/tactical" component={() => <PortTactical changeModel={this.props.changeModel} addPort={this.props.addPort} fetchData={this.props.fetchData} resetModel={this.props.resetModel} />} />
                  <Route exact path="/portfolio/tactical/funds" component={() => <PortTacticalFunds changeModel={this.props.changeModel} addPort={this.props.addPort} />} />
                  <Route exact path="/fund_selection" component={() => <FundsSelect changeModel={this.props.changeModel} fetchData={this.props.fetchData}/>} />
                  <Route exact path="/client_portfolio/load" component={() => <ClientPortLoad changeModel={this.props.changeModel} />} />
                  <Route exact path="/client_portfolio/stage/check" component={() => <ClientPortExposure changeModel={this.props.changeModel} />} />
                  <Route exact path="/client_portfolio/stage/metrics" component={() => <ClientPortMetrics changeModel={this.props.changeModel} />} />
                  <Route exact path="/client_portfolio/stage/suitability" component={() => <ClientPortSuitability changeModel={this.props.changeModel} />} />
                  <Route exact path="/client_portfolio/stage/adjust" component={() => <ClientPortAdjust changeModel={this.props.changeModel} />} />
                  <Route exact path="/market_view" component={() => <ChatStrategy changeModel={this.props.changeModel} />} />
                  <Route exact path="/suitability" component={() => <Suitability changeModel={this.props.changeModel} />} />
                  <Route exact path="/suitability/report" component={() => <SuitabilityReport changeModel={this.props.changeModel} />} />
                  <Route exact path="/downloads" component={Downloads} />
                  <Redirect to="/home"/>
                </Switch>
              </div>
            </CSSTransition>
          </TransitionGroup>
        <Footer />
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Main));
